import React, { useState, createContext, useContext, ReactNode } from "react";
import "./DealerCard.scss";
import { ChevronDown, ChevronUp, GripVertical } from "react-bootstrap-icons";

interface CollapsibleContextType {
  isOpen: boolean;
  toggle: () => void;
}

const CollapsibleContext = createContext<CollapsibleContextType | undefined>(
  undefined,
);

const DealerCard = ({
  children,
  className,
  open,
}: {
  children: ReactNode;
  className?: string;
  open?: boolean;
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen((prev) => !prev);

  return (
    <CollapsibleContext.Provider
      value={{ isOpen: open != undefined ? open : isOpen, toggle }}
    >
      <div className={"dealer-card" + (className ? " " + className : "")}>
        {children}
      </div>
    </CollapsibleContext.Provider>
  );
};

const Header = ({ children }: { children: ReactNode }) => {
  const context = useContext(CollapsibleContext);

  if (!context) {
    throw new Error("Collapsible.Header must be used within a Collapsible");
  }
  const { toggle, isOpen } = context;

  return (
    <div
      onClick={toggle}
      className={"d-flex justify-content-between dealer-card-header"}
    >
      <div className={"d-flex align-items-start"}>
        <div>
          <GripVertical width={30} height={35} className={"me-1"} />
        </div>
        {children}
      </div>
      <div>
        {isOpen ? (
          <ChevronUp width={20} height={20} />
        ) : (
          <ChevronDown width={20} height={20} />
        )}
      </div>
    </div>
  );
};

const Content = ({ children }: { children: ReactNode }) => {
  const context = useContext(CollapsibleContext);

  if (!context) {
    throw new Error("Collapsible.Content must be used within a Collapsible");
  }
  const { isOpen } = context;

  return (
    <div className={"dealer-card-content"}>
      {isOpen && <div className={"mt-3"}>{children}</div>}
    </div>
  );
};

DealerCard.Header = Header;
DealerCard.Content = Content;

export default DealerCard;
